import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "size"];
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var IconNavAboutUserAgreement = function IconNavAboutUserAgreement(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color
  }, otherProps), {}, {
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.25 6A3.75 3.75 0 017 2.25h10A3.75 3.75 0 0120.75 6v6.075a.75.75 0 11-1.5 0V6A2.25 2.25 0 0017 3.75H7A2.25 2.25 0 004.75 6v12A2.25 2.25 0 007 20.25h4.192a.75.75 0 010 1.5H7A3.75 3.75 0 013.25 18V6zm4 2A.75.75 0 018 7.25h8a.75.75 0 010 1.5H8A.75.75 0 017.25 8zM8 11.25a.75.75 0 000 1.5h4a.75.75 0 000-1.5H8z"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.25 16a2.75 2.75 0 115.194 1.263c.908.65 1.568 1.646 1.836 2.794.264 1.129-.713 1.912-1.617 1.912h-5.327c-.904 0-1.88-.783-1.617-1.912.269-1.148.93-2.145 1.838-2.795A2.74 2.74 0 0115.25 16zM18 14.75a1.25 1.25 0 00-.832 2.183.75.75 0 01-.206 1.249c-.854.364-1.54 1.178-1.782 2.216l-.001.005a.063.063 0 00.008.011.208.208 0 00.15.055h5.326a.208.208 0 00.15-.055.063.063 0 00.008-.01.16.16 0 00-.001-.006c-.243-1.038-.928-1.852-1.782-2.216a.75.75 0 01-.206-1.25A1.25 1.25 0 0018 14.75z"
    })]
  }));
};
export default IconNavAboutUserAgreement;